module.exports = __webpack_public_path__ + "assets/images/date46d0dc61ab4bea391338fa3c9ef04f60.svg";